import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ModalAddNewContactComponent } from "../../../contact/component/addContact/modal-add-new-contact";
import { NbcLoggerService } from "../../logger/nbc-logger.service";
import { BusinessUnitService } from "../../services/business-unit.service";
import { ContactService } from "../../services/contact.service";
import { SharedDataService } from "../../sharedData.service";

 
 

@Component({
  selector: "contact-flyover",
    templateUrl: "./contact-flyover.component.html",
    standalone: false
})
export class ContactFlyoverComponent implements OnInit, OnDestroy {
    sso = "";
    perNer = "";
    firstName = "";
    lastName = "";
    flyout: boolean;
    businessSubSegment = "";

    contacts: any;
    contactQuery: any;
    hasSearchResults = false;
    contactQueryValidateAlerts = [];
    selectedBuId: any = 0;
    buAccess: any;
    departments: any;

    constructor(
        private _modalService: BsModalService,
        private contactService: ContactService,
        private _sharedDataService: SharedDataService,
        private _activatedRoute: ActivatedRoute,
        private businessUnitService: BusinessUnitService,
        private log: NbcLoggerService
    ) {
      this._sharedDataService.contactFlyoverSubject.subscribe(
        (data) => {
         // console.log("call received:", data)
                this.flyout = true;
            }
        );
    }

    showFlyout(event) {
        this.flyout = true;
    }

    toggleFlyout() {
        this.flyout = !this.flyout;
    }

    initializeContactQueryObjectAndProperties() {
        this.contactQuery = this.contactService.getDefaultContactQuery();
        this.contactQuery.pageSize = 20;
    }

    isOneFieldEntered() {
        if (
            (this.contactQuery.firstName === "" ||
                this.contactQuery.firstName === null) &&
            (this.contactQuery.lastName === "" ||
                this.contactQuery.lastName === null) &&
            (this.contactQuery.sso === "" || this.contactQuery.sso === null) &&
            (this.contactQuery.perNer === "" ||
                this.contactQuery.perNer === null) &&
            (this.contactQuery.businessSubSegment === "" ||
                this.contactQuery.businessSubSegment === null)
        ) {
            return false;
        } else {
            return true;
        }
    }

    reset() {
        this.log.trace("cancel");
        this.contactQueryValidateAlerts = [];
        this.contactQuery = this.contactService.getDefaultContactQuery();
        this.contacts = {};
    }

    searchContacts(isValid: any) {
        this.log.trace("searchContacts");
        this.contactQueryValidateAlerts = [];
        if (isValid && this.isOneFieldEntered()) {
            //this.contactQuery.venue = this.contactQuery.workedAtVenue ? this.eventVenue : "";
            this.contactQuery.limit = 50;
            //usSpinnerService.spin("spinner");
            this.contactService.search(this.contactQuery).subscribe(
                (result) => {
                    this.contacts = result;
                    this.hasSearchResults = true;
                    //self.setcontactsscope();
                    //usspinnerservice.stop("spinner");
                },
                (err) => {
                    this.log.error(err);
                    this.log.showModalError(
                        "Unable to load the timesheet template at this time. Please try again later."
                    );
                }
            );
        } else {
            this.contactQueryValidateAlerts.push({
                type: "danger",
                msg: "Please enter a search criterion",
            });
        }
    }

    openAddContactModal() {
        let bsModalRef: BsModalRef;
        const initialState: any = {
            // userBuAccess: this.selectedBuAccess,
            businessUnitId: this.selectedBuId,
            departmentId: this.departments,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        bsModalRef = this._modalService.show(
            ModalAddNewContactComponent,
            modalOptions
        );
    }

    subscribeEventHandlers() {
        this._activatedRoute.params.subscribe((params) => {
            if (params["buid"]) {
                this.selectedBuId = params["buid"];
                this.getBusinessUnitDepartments();
            }
        });
    }

    getBusinessUnitDepartments() {
        this.businessUnitService.getBuDept(this.selectedBuId).subscribe({
            next: (result) => {
                this.departments = result.reference;
            },
        });
    }

    ngOnInit() {
       // this._sharedDataService.setCss("timesheet");
        this.subscribeEventHandlers();
        this.initializeContactQueryObjectAndProperties();
        this.isOneFieldEntered();
    } 

  public ngOnDestroy() {
   // this._sharedDataService.contactFlyoverSubject?.unsubscribe();
    }
}
